//
// 天気の表記統一。
//
// 生コン帳票の天候欄は同じ意味でも「晴れ」「晴」のように送り仮名の有無が帳票ごとに揺れる
// （同一フォーマットでもどちらもあり得る、というのが人間裁定の実測。PR #821 レビュー）。
// TestResult では検索・比較のしやすさを優先し、**短形（晴・曇・雨・雪）へ寄せて統一する**。
// 短形を選んだのは、OCRモデルの出力が実測でほぼ短形であることと、丸囲み選択式の帳票
// （晴・曇・雨から選ぶ）の印字が短形であるため。
//
// 完全一致した単純な天気語だけを変換する。「晴れのち曇り」のような複合表現は
// 情報を壊さないようそのまま保持する（必要になったら拡張する）。
//
const WEATHER_ALIASES: Record<string, string> = {
  晴れ: '晴',
  はれ: '晴',
  曇り: '曇',
  くもり: '曇',
  あめ: '雨',
  ゆき: '雪',
}

export function normalizeWeather(value: string): string {
  const trimmed = value.trim()
  return WEATHER_ALIASES[trimmed] ?? trimmed
}
